import { useEffect, useRef } from "react";

const useClickOutsideCallback = (ref: React.RefObject<HTMLElement>, callback: () => void) => {
    // Keep the latest callback without re-registering the listener each render;
    // the effect below deliberately depends on [ref] only, so calling `callback`
    // directly there would freeze the first render's closure (stale state).
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (ref.current && !ref.current.contains(target)) {
                callbackRef.current();
            }
        };

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [ref]);
}

export default useClickOutsideCallback;
